import ISuppliesRepository from '../domain/ISuppliesRepository';
import { warehouseRankingMapper } from '../domain/warehouseRankingMapper';
import suppliesRepository from '../infrastructure/repositories/SuppliesRepository';

class GetWarehousesTargetService {
  private readonly _suppliesRepository: ISuppliesRepository;

  constructor({ suppliesRepository }) {
    this._suppliesRepository = suppliesRepository;
  }

  execute({ queryParams }: { queryParams: object }) {
    return this._suppliesRepository
      .getWarehousesTarget({ queryParams })
      .then((res) => warehouseRankingMapper(res));
  }
}

export default new GetWarehousesTargetService({
  suppliesRepository: suppliesRepository
});

export { GetWarehousesTargetService };
